export default "__VITE_ASSET__Dqo5ViII__"